import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { setHighestZIndexForOpenModals } from '../../../util/common-utils'
import { TransactionConstants } from '../../../util/constants'

@Component({
  selector: 'hs-delete-bulk-transactions-confirm-modal',
  template: `
    <div class="modal-header" hsDraggable="modal-dialog">
      <h4 class="modal-title">Bulk Transaction Remove Row(s)</h4>
      <button
        nf-icon-button
        icon="close"
        class="btn-bare"
        ngbTooltip="Close"
        (click)="activeModal.dismiss()"
      >
        Close
      </button>
    </div>
    <div
      *ngIf="rowsToDelete.length > 0"
      class="modal-body"
      hsDraggable="modal-dialog"
    >
      <h5>Are you sure you want to remove these transaction row(s)?</h5>
      <p>
        {{ rowsToDelete.join(',') }}
      </p>
    </div>
    <div
      *ngIf="rowsToDelete.length == 0"
      class="modal-body"
      hsDraggable="modal-dialog"
    >
      <h5>Please select atleast one active transaction row</h5>
    </div>
    <div class="modal-footer" hsDraggable="modal-dialog">
      <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
      <button
        *ngIf="rowsToDelete.length > 0"
        nf-button="submit"
        (click)="activeModal.close(true)"
      ></button>
    </div>
  `,
})
export class DeleteBulkTransactionsModalComponent implements OnInit {
  @Input() rowsToDelete: number[] = []

  readonly compId = TransactionConstants.BULK_ROWS_DELETE_COMP_ID

  constructor(
    public activeModal: NgbActiveModal,
    private readonly eleRef: ElementRef,
  ) {}

  ngOnInit() {
    setHighestZIndexForOpenModals(this.compId, this.eleRef)
  }

  getComponentId() {
    return this.compId
  }
}
